import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { formatDate } from '@angular/common';

@Component({
  selector: 'user-profile-component',
  templateUrl: '../sharedTemplates/user-profile.component.html',
})
export class UserProfileComponent implements OnInit, AfterViewInit {
  userprofileDatas: UntypedFormGroup;
  userprofileDataRaw: any;
  personalInfoDropDownIsOpen = true;
  changePasswordDropDownIsOpen = false;
  settingsDropDownIsOpen = false;
  langDropDownIsOpen = false;

  //bet3000
  langDatas;
  langDatasArry = [];
  selectedLang = '';
  //bet3000
  // COMBO
  CountryList;
  PhoneNumberList;
  PasswordQuestionList;
  BirthPlaceList;

  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    private _FormBuilder: UntypedFormBuilder
  ) {
    this.userprofileDatas = _FormBuilder.group({
      Address: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      AddressAdditional: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Balance: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Birthday: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      BranchId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      BrancName: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      City: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Country: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CountryId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CreateDate: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Currency: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CurrencyId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CustomerId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CustomerName: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      CustomerSurname: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Email: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      GroupId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      GroupName: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      IpAddress: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      IsActive: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      IsOddDecreasements: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      IsOddIncreasement: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      Language: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      LanguageId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      LastLoginDate: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      OddsFormatId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      OddsFormatName: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Password: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PasswordAnswer: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PasswordQuestion: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PasswordQuestionId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PhoneCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PhoneCodeId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PhoneNumber: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, Validators.min(1000000000), Validators.max(99999999999)]),
      Salutation: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      SalutationId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Sybol: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      TimeZone: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      TimeZoneId: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      Username: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      ZipCode: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PassportNo: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      TaxNo: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      BirthPlace: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
      PromotionPermission: new UntypedFormControl({ value: true, disabled: false }, [Validators.required]),
      IdNumber: new UntypedFormControl({ value: '', disabled: true }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.userProfileListChange();
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('User_Profile', false);
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }
    this.getCountryList();

    //bet3000
    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    this.langDatasArry.push(this.langDatas[this.selectedLang]);
    Object.keys(this.langDatas).forEach(x => {
      if (x !== this.selectedLang) {
        this.langDatasArry.push(this.langDatas[x]);
      }
    });
    //bet3000
  }

  userProfileListChange() {
    this.userprofileDatas.valueChanges.subscribe(x => {
      this.userprofileDataRaw = this.userprofileDatas.getRawValue();
    });
  }

  getCustomerOne() {
    this._ApiService.getCustomerOne().then(CustomerOne => {
      // this.userProfileList = CustomerOne[0];
      this._UiHelper.userProfileList = CustomerOne[0];
      this.userprofileDatas.patchValue(this._UiHelper.userProfileList);
    });
  }

  getCountryList() {
    this._ApiService.getCountryList().then(CountryList => {
      this.CountryList = CountryList;
      this.BirthPlaceList = CountryList;
      this.getComboPhoneNumberList();
    });
  }

  getComboPhoneNumberList() {
    this._ApiService.getComboPhoneNumberList().then(PhoneNumberList => {
      this.PhoneNumberList = PhoneNumberList;
      this.getComboPasswordQuestionList();
    });
  }

  getComboPasswordQuestionList() {
    this._ApiService.getComboPasswordQuestionList().then(PasswordQuestionList => {
      this.PasswordQuestionList = PasswordQuestionList;
      this.getCustomerOne();
    });
  }

  Update() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.saveCustomerDetail(this.userprofileDataRaw).then(result => {
      if (result.code == 'error') {
        this._UiHelper.errorSnackBar(result.message, '');
      } else if (result.code == 'errorcode') {
        const t_message = translator.transform(result.message, null);

        this._UiHelper.errorSnackBar(t_message, '');
      } else if (result.code == 'success') {
        const t_message = translator.transform(result.message, null);

        this._UiHelper.successSnackBar(t_message, '');
        this.getCustomerOne();
        this.userprofileDatas.disable();
      }
    });
  }
  toggleDropDown(item) {
    if (item == 1) {
      this.personalInfoDropDownIsOpen = !this.personalInfoDropDownIsOpen;
    } else if (item == 2) {
      this.changePasswordDropDownIsOpen = !this.changePasswordDropDownIsOpen;
    } else if (item == 3) {
      this.settingsDropDownIsOpen = !this.settingsDropDownIsOpen;
    } else if (item == 4) {
      this.langDropDownIsOpen = !this.langDropDownIsOpen;
    }
  }

  selectionChange(x) {
    this._LocalizationService.changeLang(x);
    // this.isOpenLangMenu = !this.isOpenLangMenu
  }
  changeTheme() {
    this._UiHelper.darkThemeListener.emit();
  }
}
